export default () => {
  document.addEventListener("DOMContentLoaded", () => {
    const elements = document.querySelectorAll(".fly");

    elements.forEach((el) => {
      let x = 0, y = 0;

      function floatEffect() {
        const dx = (Math.random() - 0.5) * 6;
        const dy = (Math.random() - 0.5) * 6;
        x += dx;
        y += dy;

        el.style.transition = "transform 1.5s ease-in-out";
        el.style.transform = `translate(${x}px, ${y}px)`;

        setTimeout(floatEffect, 1200 + Math.random() * 1000);
      }

      floatEffect();
    });
  });
};
